export interface tag {
    title: string;
    color: string;
    textColor: string;
    id?: string;
    tenantId?: string;
    groupId?: string;
};